import { useSelector } from 'react-redux';
import { State } from '../../../reducers';
import {
  LPStakingPool,
  NakedStakingPool,
  StakingPool,
} from '../../../services/staking/staking.types';

//@TODO would be good to move this all to redux with redux-thunk
export function UseLpStakingPool() {
  const { pools, poolId } = useSelector(({ StakingPools, stakingPool }: State) => ({
    pools: StakingPools as StakingPool[],
    poolId: stakingPool.selectedPoolId,
  }));

  const pool = pools.filter(
    ({ stakingContractAddress }) => stakingContractAddress === poolId,
  )[0] as LPStakingPool;
  return pool;
}

export function useNakedStakingPool() {
  const { pools, poolId } = useSelector(({ StakingPools, stakingPool }: State) => ({
    pools: StakingPools as StakingPool[],
    poolId: stakingPool.selectedPoolId,
  }));

  const pool = pools.filter(
    ({ stakingContractAddress }) => stakingContractAddress === poolId,
  )[0] as NakedStakingPool;
  return pool;
}
